import { useParams, usePathname } from 'next/navigation';

import useUser from '@/hooks/swr/useUser';
import useUserRole from '@/hooks/user/useUserRole';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

// Lib
import { pagesWithoutSubscription } from '@/lib/middleware/accessControl/pagesWithoutSubscription';

import { ACCOUNT, SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

export const useRequiresSubscription = () => {
    const { user } = useUser();
    const { isAdmin } = useUserRole();

    const params = useParams();
    const pathname = usePathname();

    /**
     * Replace url parameters with the real value
     */
    const formattedUrl = formatUrls(pagesWithoutSubscription, params);

    /**
     * Check if the user has access to the page
     */
    const noAccess = !user?.subscribed_or_trial && !formattedUrl.includes(pathname);
    const redirect_url = isAdmin ? SUBSCRIPTION_INVOICES : ACCOUNT;

    return { hasAccess: !noAccess, redirect_url };
};
